function Hero({ currentDesk, onNavigate }) {
  const trustItems = currentDesk.trustItems || [];

  return (
    <section
      className="hero"
      style={{ '--hero-image': `url(${currentDesk.heroImage})` }}
    >
      <div className="hero-overlay" />
      <div className="hero-grid">
        <div className="hero-copy">
          <span className="kicker">{currentDesk.kicker}</span>
          <h1>Chinatao</h1>
          <p className="hero-lead">{currentDesk.title}</p>
          <p className="hero-text">{currentDesk.description}</p>

          {trustItems.length > 0 && (
            <div className="trust-strip" aria-label="Преимущества сервиса">
              {trustItems.map((item) => (
                <span className="trust-pill" key={item}>{item}</span>
              ))}
            </div>
          )}

          <div className="hero-actions">
            <button className="button button-primary" type="button" onClick={() => onNavigate('contact')}>
              Оставить заявку
            </button>
            <button className="button button-ghost" type="button" onClick={() => onNavigate('services')}>
              Смотреть услуги
            </button>
          </div>
        </div>

        <div className="hero-panel" aria-label="Маршрут работы">
          <div className="route-card">
            <span>Маршрут</span>
            <ol>
              {currentDesk.route.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ol>
          </div>

          <div className="stat-stack">
            {currentDesk.stats.map(([number, text]) => (
              <div className="hero-stat" key={text}>
                <strong>{number}</strong>
                <span>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
